import { TIPO_CITA } from 'src/app/common/constants-ejb';

/** Datos para abrir la gestión de contactos del informe (GestionarContactosInformeDialogComponent.abrir). */
export interface GestionContactosInformePendiente {
  radicado: number;
  cumplimientos: string;
}

/**
 * Legacy (CreateOrUpdateCumplimientoActivity.procesarCumplimientoInforme + gestionarContactosInforme):
 * tras guardar un cumplimiento de tipo de cita INFORME con informe Final (ivasnparcial = 'N'), se abre
 * la gestión de contactos del informe con el radicado (NM_RADICADO) y el cumplimiento guardado.
 *
 * @returns los datos para abrir el diálogo, o null si no aplica
 */
export function gestionContactosInformeSiAplica(
  request: { tipoInforme?: string | null; cdtipoCita?: number | null } | null | undefined,
  response: {
    nmRadicadoInforme?: number | null;
    nmconsecutivo?: number | null;
    nmconsecutivoTipoCita?: number | null;
    informeParcial?: boolean | null;
  } | null | undefined
): GestionContactosInformePendiente | null {
  if (!request || !response?.nmRadicadoInforme || !response.nmconsecutivo) {
    return null;
  }
  const tipoCita = Number(response.nmconsecutivoTipoCita ?? request.cdtipoCita);
  // El backend informa el valor efectivo: para clientes que no son la ARL el informe es siempre Final aunque se
  // haya elegido Parcial. Sin ese dato (respuesta anterior) se usa lo elegido en el formulario.
  const informeParcial = response.informeParcial ?? request.tipoInforme !== 'F';
  if (informeParcial || tipoCita !== TIPO_CITA.INFORME) {
    return null;
  }
  return {
    radicado: Number(response.nmRadicadoInforme),
    cumplimientos: String(response.nmconsecutivo)
  };
}
